import { baseApi } from '@klp/core/api';

import { fakturaApiRoutes } from './api';
import { Faktura } from './classes';
import type { FakturaRequest, FakturaResponse } from './classes';
import type { IFakturaInput } from './classes/IFakturaInput';

export const fakturaApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getFakturaList: builder.query<FakturaResponse, FakturaRequest>({
            query: (requestParams) => ({
                url: fakturaApiRoutes.list(),
                params: requestParams,
            }),
            transformResponse: (
                response: Array<IFakturaInput>,
            ): FakturaResponse => {
                const fakturaList = response.map((faktura: IFakturaInput) =>
                    Faktura.parseObject(faktura),
                );
                return { fakturaList };
            },
            providesTags: ['Faktura'],
        }),
    }),
});

export const { useGetFakturaListQuery, useLazyGetFakturaListQuery } =
    fakturaApi;
